module.exports = __webpack_public_path__ + "static/media/robo-full.179ee6f0.png";